/** Human-readable byte size (B / KB / MB). */
export function fmtSize(n?: number): string {
  if (!n) return '';
  if (n < 1024) return `${n} B`;
  if (n < 1024 * 1024) return `${Math.round(n / 1024)} KB`;
  return `${(n / 1024 / 1024).toFixed(1)} MB`;
}

const pad2 = (n: number) => String(n).padStart(2, '0');
/** Date as DD/MM-YYYY (e.g. 08/10-2026), local time. */
export function fmtDay(ms?: number): string {
  if (!ms) return '';
  const d = new Date(ms);
  return `${pad2(d.getDate())}/${pad2(d.getMonth() + 1)}-${d.getFullYear()}`;
}
/** Date + time as DD/MM-YYYY HH:MM (24 h), local time. */
export function fmtDayTime(ms?: number): string {
  if (!ms) return '';
  const d = new Date(ms);
  return `${fmtDay(ms)} ${pad2(d.getHours())}:${pad2(d.getMinutes())}`;
}
